import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone'
import config from '../../config'

// documents d'identitat: sempre han de ser una foto/escaneig, mai un PDF (el fullprint
// els necessita com a imatge per mostrar-los dins la fitxa, no com a document a part)
const NOMES_IMATGE_IDS = [
  "fotoCarnetFile",
  "iddocumentFrontFile",
  "iddocumentBackFile",
  "progenitor1IDFrontFile",
  "progenitor1IDBackFile",
  "progenitor2IDFrontFile",
  "progenitor2IDBackFile",
]

function DropZone(props) {

  const acceptaPdf = !NOMES_IMATGE_IDS.includes(props.id)

const [loading, setLoading] = useState(false);

  const onDrop = useCallback(async (acceptedFiles) => {

    props.handleFileError(null)
    if(props.handleFileInfo) props.handleFileInfo(null)


    let file = acceptedFiles[0];

    const MAXSIZE = 4


    if (file.size > MAXSIZE * 1024 * 1024) {
      props.handleFileError("Arxiu massa gran màxim " + MAXSIZE + "MB")
      props.onChange()
      return
    }

    if (file) {

      const esImatgeValida = /^image\/png/.test(file.type) || /^image\/jpeg/.test(file.type)
      const esPdfValid = acceptaPdf && /^application\/pdf/.test(file.type)

      if (!esImatgeValida && !esPdfValid) {
        props.onChange()
        props.handleFileError(acceptaPdf
          ? "Tipus d'arxiu no vàlid. S'accepten imatges JPG, PNG o PDF."
          : "Tipus d'arxiu no vàlid. S'accepten imatges JPG o PNG.")
        return
      }

    const switchDropType = async () => {
        switch (props.id) {

        // VALIDACIÓ FOTO CARNET
          case "fotoCarnetFile":
            {

            if(config.validaIAfotoCarnetFile){
              setLoading(true);

              const { validatePassportPhoto, loadFaceModels }= await import('../validators/validatePassportPhoto')

              await loadFaceModels();

              const result = await validatePassportPhoto(file);
              setLoading(false);

              if (!result.valid) {

                props.handleFileError(result.reason)
                props.onChange()

                return false

              }

              if(props.handleFileInfo) props.handleFileInfo(result.reason)

              // si la IA ha hagut de girar la imatge per trobar-hi la cara (foto pujada de
              // costat o cap per avall), fem servir la versió ja girada en comptes de l'original
              if (result.rotatedFile) return result.rotatedFile
            }

              return null
            }

        // VALIDACIÓ CARNET IDENTITAT DAVANT
          case "iddocumentFrontFile":
            {


              /*
              if (config.validaIAiddocumentFrontFile) {
                setLoading(true);
                const result = await validateDNIDavant(file, props.setDebugPreview);
                setLoading(false);

                if (!result.valid) {

                props.handleFileError(result.reason)
                props.onChange()

                } else {

                  if(props.handleFileInfo) props.handleFileInfo(result.reason)

                  }

                  }
                */

              return null
            }

          default:
            return null
        }
      }


      const resultatValidacio = await switchDropType()

      // validació fallida: ja s'ha netejat l'arxiu i mostrat l'error dins de switchDropType
      if (resultatValidacio === false) return

      // si la validació ha girat la imatge, fem servir aquesta versió en comptes de l'original
      if (resultatValidacio) file = resultatValidacio


      // si arriba aquí és correcta
      const reader = new FileReader()

      reader.onabort = () => console.log('file reading was aborted')
      reader.onerror = () => console.log('file reading has failed')

      reader.onload = () => {

        const fileContent = reader.result

        props.onChange({
          file: file,
          fileContent: fileContent
        })

      }

      reader.readAsDataURL(file)

    }

  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptaPdf
      ? { 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'], 'application/pdf': ['.pdf'] }
      : { 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'] }
  })
 

  return (<>

    <div className={'col ' + props.col}>
      <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id={props.id + '_CONTAINER'}>
        
        <div className="t-Form-labelContainer">
          <label htmlFor={props.id} id={props.id + '_LABEL'} className="t-Form-label">
            {props.label}
            <small>{props.labelSmall}{props.obligatori ? (<sup>*</sup>) : ""}</small>
          </label>
        </div>

        <div className="t-Form-inputContainer">

          <div className="t-Form-itemWrapper">
            <div {...getRootProps()} style={{ width: '100%' }}>

    { loading ? 
    (<div className="loadingText" >analitzant arxiu amb IA<span></span></div>)
    :
    (<>
            <input {...getInputProps()} />

            {isDragActive && <p>Arrossega l'arxiu fins aquí ...</p>}

            {!isDragActive && (
              <div className="dropZone">
                {props.file?.file ? props.file.file.name : props.labelDrop}
              </div>
            )}

        </>)
      }
  

          </div>
          </div>

          <span id={props.id + '_INFO'} className="a-Form-info">{props.info}</span>
          <span id={props.id + '_ERROR'} className="a-Form-error">{props.error}</span>

        </div>

      </div>
    </div>
  </>)

}


export default DropZone